var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "room-device-setting-modal-component",
      on: { click: _vm.closeModal },
    },
    [
      _c(
        "div",
        {
          staticClass: "room-device-setting-modal",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [_c("CamstudyPreview")],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }